export default __webpack_public_path__ + "static/twiggy-90cc00d52b43878231e2264d01f0a56b.svg";